import { render, staticRenderFns } from "./PrapaWelcome.vue?vue&type=template&id=03af27ce&"
import script from "./PrapaWelcome.vue?vue&type=script&lang=js&"
export * from "./PrapaWelcome.vue?vue&type=script&lang=js&"
import style0 from "./PrapaWelcome.vue?vue&type=style&index=0&id=03af27ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports